/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DataManagerEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const dataManagerEntryPoint: EntryPoint<DataManagerEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<DataManagerEntryPointComponent>(
			/* webpackChunkName: "async-insight-global-configuration-data-manager-main" */ './DataManagerMain.tsx',
		),
		getPreloadProps: () => ({}),
	});
